var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VxConfirmDialog',{attrs:{"hide-cancel":"","value":true,"ok-text":"Retry"},on:{"ok":_vm.refresh}},[_vm._v(" ResaleAI POS failed to login automatically. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }